/* global UIKIT */

'use strict';

// Constructor
var Accordion = function () {
    var i = 0;
    try {
        var accordionToggles = document.querySelectorAll('.accordion-toggle');
        for (i = 0; i < accordionToggles.length; i++) {
            var elem = accordionToggles[i];
            elem.addEventListener('click', function (e) {
                e.preventDefault();
                UIKIT.accordion.Toggle(e.target);
            });
        }
    } catch (e) {
        console.log(e); 
    }
    var $accordion = $(".uikit-accordion");
    var windowHash = window.location.hash
    $accordion.each(function(i, v){
        var $this = $(this); 
        var $findAnchor = $this.find(".field__item").find(windowHash)
        if($findAnchor.length>0){
            UIKIT.accordion.Toggle($this.find(".accordion-toggle"));
        }
    });
};

module.exports = Accordion;